import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import { Flyout } from '@els/els-react--flyout';

import './HoverTooltip.theme.scss';

export default function HoverTooltip({ id, tooltip, children, className, width, tag, tooltipPlace, theme, isDisabled }) {
  const Tag = tag ? `${tag}` : 'div';
  const tooltipTrigger = React.Children.toArray(children).filter(Boolean);

  return tooltip ? (
    <Flyout
      placement={tooltipPlace || 'top-start'}
      trigger="hover"
      width={width || 'max-content'}
      theme={theme || 'default'}
      isDisabled={isDisabled || false}
      id={id}
      pointerType="primary"
      className={className}
      flyout={<Tag dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(tooltip) }} />}>
      {tooltipTrigger}
    </Flyout>
  ) : (
    <div className={className}>{tooltipTrigger}</div>
  );
}

HoverTooltip.propTypes = {
  id: PropTypes.string,
  tooltip: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  theme: PropTypes.string,
  isDisabled: PropTypes.bool,
  tag: PropTypes.string,
  tooltipPlace: PropTypes.string,
};
